import { Injectable } from "@angular/core";

import { ApiTemplate } from "../base/template/api.template";
import { Account, AccountRequest } from "./model/account.model";

@Injectable({ providedIn: 'root' })
export class AccountApi extends ApiTemplate<Account, AccountRequest> {
    constructor() {
        super('http.rest.identity.url', "/api/accounts");
    }
}
